import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

export const useSavedLaneFormBodyStyles = makeStyles(theme => ({
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',

    [theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  switchWrapper: {
    paddingBottom: theme.spacing(8),

    [theme.breakpoints.up('md')]: {
      paddingBottom: 0,
      marginBottom: theme.spacing(2),
    },

    [theme.breakpoints.up('lg')]: {
      marginBottom: 0,
    },
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    background: brandColors.white,
    padding: theme.spacing(3),

    [theme.breakpoints.up('md')]: {
      position: 'static',
      background: brandColors.transparent,
      padding: 0,
    },
  },
}))
